import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  renderTurboStream(content) {
    if (window.Turbo && typeof window.Turbo.renderStreamMessage === "function") {
      window.Turbo.renderStreamMessage(content);
      return true;
    }
    return false;
  }


  payCancelledLesson(event) {
    event.preventDefault();
    const url = this.data.get('payUrl');
    window.location.href = url;
  }

  takeOnlinePayment(event) {
    const lessonId = document.getElementById('lesson-id').value;
    window.location.href = `/schools/us/dashboard/lessons/${lessonId}/no-show/take-online-payment`
  }

  waiveFeeJson(event) {
    event.preventDefault(); // Prevent the default form submission

    let lessonId = event.currentTarget.dataset.lessonId; 
    if (lessonId == null) {
      lessonId = document.getElementById('lesson-id').value;
    }

    const url = `/schools/us/dashboard/lessons/${lessonId}/no_show/waive-fee`;

    fetch(url, { method: 'GET', headers: {
      "Accept": "application/json",
       "Content-Type": "application/json"
     }})
      .then(response => {
        if (!response.ok) throw new Error("Fee waiver failed");
        return response.text();
      })
      .then(content => {
        if (document.getElementById("school_pupils_packages_payments_v2")) {
          window.dispatchEvent(new CustomEvent("driving-school-student-payments-v2:refresh"));
        } else {
          alert('Fee waived');
          window.location.reload();
        }
      })
      .catch(error => 
        alert('Error waiving fee')
      );
  }

  waiveFee(event) {
    event.preventDefault(); // Prevent the default form submission

    let lessonId = event.currentTarget.dataset.lessonId; 
    if (lessonId == null) {
      lessonId = document.getElementById('lesson-id').value;
    }

    const url = `/schools/us/dashboard/lessons/${lessonId}/no_show/waive-fee`;

    fetch(url, { method: 'GET', headers: { "Accept": "text/vnd.turbo-stream.html", 'Turbo-Frame': 'school_lesson_no_show_payment' } })
      .then(response => response.text())
      .then(content => {
        const rendered = this.renderTurboStream(content);
        if (!rendered) {
          window.location.reload();
        }
      })
      .catch(error => console.error(error));
  }

  sendEmailReminder(event) {
    event.preventDefault(); // Prevent the default form submission
    const lessonId = document.getElementById('lesson-id').value;

    const url = `/schools/us/dashboard/lessons/${lessonId}/no_show/email-reminder`;

    fetch(url, { method: 'GET', headers: { "Accept": "text/vnd.turbo-stream.html", 'Turbo-Frame': 'school_lesson_no_show_payment' } })
      .then(response => response.text())
      .then(content => {
        this.renderTurboStream(content);
      })
      .catch(error => console.error(error));
  }
}
